const application = {
    invalid_type: 'Apenas as aplicações de máquina a máquina podem ter funções associadas.',
    role_exists: 'O id da função {{roleId}} já foi adicionado a esta aplicação.',
    invalid_role_type: 'Não é possível atribuir uma função de tipo de utilizador a uma aplicação de máquina a máquina.',
    invalid_third_party_application_type: 'Apenas aplicações web tradicionais podem ser marcadas como uma aplicação de terceiros.',
    third_party_application_only: 'A funcionalidade só está disponível para aplicações de terceiros.',
    user_consent_scopes_not_found: 'Escopos de consentimento de utilizador inválidos.',
    /** UNTRANSLATED */
    consent_management_api_scopes_not_allowed: 'Management API scopes are not allowed.',
    protected_app_metadata_is_required: 'Protected app metadata is required.',
    /** UNTRANSLATED */
    protected_app_not_configured: 'Protected app provider is not configured. This feature is not available for open source version.',
    /** UNTRANSLATED */
    cloudflare_unknown_error: 'Got unknown error when requesting Cloudflare API',
    /** UNTRANSLATED */
    protected_application_only: 'The feature is only available for protected applications.',
    /** UNTRANSLATED */
    protected_application_misconfigured: 'Protected application is misconfigured.',
    /** UNTRANSLATED */
    protected_application_subdomain_exists: 'The subdomain of Protected application is already in use.',
    /** UNTRANSLATED */
    invalid_subdomain: 'Invalid subdomain.',
    /** UNTRANSLATED */
    custom_domain_not_found: 'Custom domain not found.',
    /** UNTRANSLATED */
    should_delete_custom_domains_first: 'Should delete custom domains first.',
};
export default Object.freeze(application);
